// Componente para mostrar carrusel de imágenes de perfil del usuario (versión web).
// Usa scroll horizontal para navegar entre imágenes.
// Adaptado para web desde amarsi-app (React Native a React DOM).

import React, { useState } from 'react';
import { FiChevronLeft, FiChevronRight, FiX } from 'react-icons/fi';

export default function CarouselCards({ data }) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalIndex, setModalIndex] = useState(0);

  if (!data || data.length === 0) {
    return (
      <div className="relative w-full aspect-square bg-gray-800 md:max-w-[8rem] md:max-h-[8rem] md:mx-auto md:rounded-lg md:overflow-hidden flex items-center justify-center">
        <img
          src="/default-avatar.png"
          alt="Avatar por defecto"
          className="w-full h-full object-cover"
          onError={(e) => {
            e.target.style.display = 'none';
          }}
        />
      </div>
    );
  }

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % data.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev - 1 + data.length) % data.length);
  };

  const openModal = (index) => {
    setModalIndex(index);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const nextModalSlide = () => {
    setModalIndex((prev) => (prev + 1) % data.length);
  };

  const prevModalSlide = () => {
    setModalIndex((prev) => (prev - 1 + data.length) % data.length);
  };

  return (
    <div className="relative w-full aspect-square bg-gray-800 md:w-auto md:h-auto md:max-w-[28rem] md:max-h-[28rem] md:mx-auto md:rounded-lg md:overflow-hidden">
      {/* Imagen actual */}
      <img
        src={data[currentIndex]?.url}
        alt={`Foto ${currentIndex + 1}`}
        className="w-full h-full object-cover cursor-pointer"
        onClick={() => openModal(currentIndex)}
        onError={(e) => {
          e.target.src = '/default-avatar.png';
        }}
      />

      {/* Indicador de posición */}
      {data.length > 1 && (
        <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex gap-2">
          {data.map((_, index) => (
            <div
              key={index}
              className={`w-2 h-2 rounded-full transition-colors ${
                index === currentIndex ? 'bg-white' : 'bg-white/50'
              }`}
            />
          ))}
        </div>
      )}

      {/* Botones de navegación */}
      {data.length > 1 && (
        <>
          <button
            onClick={prevSlide}
            className="absolute left-2 top-1/2 transform -translate-y-1/2 bg-black/50 hover:bg-black/70 rounded-full p-2 transition-colors"
          >
            <FiChevronLeft size={24} color="white" />
          </button>
          <button
            onClick={nextSlide}
            className="absolute right-2 top-1/2 transform -translate-y-1/2 bg-black/50 hover:bg-black/70 rounded-full p-2 transition-colors"
          >
            <FiChevronRight size={24} color="white" />
          </button>
        </>
      )}

      {/* Modal para ver imagen en grande */}
      {isModalOpen && (
        <div
          className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4"
          onClick={closeModal}
        >
          <div
            className="relative max-w-full max-h-full flex items-center justify-center"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Imagen en grande */}
            <img
              src={data[modalIndex]?.url}
              alt={`Foto ${modalIndex + 1}`}
              className="max-w-full max-h-full object-contain"
              onError={(e) => {
                e.target.src = '/default-avatar.png';
              }}
            />

            {/* Botón cerrar */}
            <button
              onClick={closeModal}
              className="absolute top-4 right-4 bg-black/50 hover:bg-black/70 rounded-full p-2 transition-colors"
            >
              <FiX size={24} color="white" />
            </button>

            {/* Botones de navegación en modal */}
            {data.length > 1 && (
              <>
                <button
                  onClick={prevModalSlide}
                  className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-black/50 hover:bg-black/70 rounded-full p-2 transition-colors"
                >
                  <FiChevronLeft size={32} color="white" />
                </button>
                <button
                  onClick={nextModalSlide}
                  className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-black/50 hover:bg-black/70 rounded-full p-2 transition-colors"
                >
                  <FiChevronRight size={32} color="white" />
                </button>
              </>
            )}

            {/* Indicador de posición en modal */}
            {data.length > 1 && (
              <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex gap-2">
                {data.map((_, index) => (
                  <div
                    key={index}
                    className={`w-3 h-3 rounded-full transition-colors ${
                      index === modalIndex ? 'bg-white' : 'bg-white/50'
                    }`}
                  />
                ))}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
